import { Pipe, PipeTransform } from '@angular/core';
import { LabelDetailDto } from '@artemis-software/wr-api';
import CategoryEnum = LabelDetailDto.CategoryEnum;

@Pipe({
  standalone: false,
  name: 'labelCategoryTranslation'
})
export class LabelCategoryPipe implements PipeTransform {
  transform(value: CategoryEnum | undefined | null): string {
    switch (value) {
      case CategoryEnum.Heat:
        return 'Wärme';
      case CategoryEnum.ColdWater:
        return 'Kaltwasser';
      case CategoryEnum.GeneralElectricity:
        return 'Allgemeinstrom';
      case CategoryEnum.Solar:
        return 'Solar';
      case CategoryEnum.None:
        return 'Keine';
      default:
        return 'Unbekannt';
    }
  }
}
